<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :data="tableData"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      :footer-method="() => footerData"
      :edit-config="{ trigger: 'click', mode: 'row', enabled: !disabled }"
      :edit-rules="editRules"
    >
      <template v-slot:toolbar_form>
        <div class="d-flex align-items-stretch">
          <div class="side-frame"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title_sample') || '样品需求填报' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="add()"
            >
              {{ $l('btn_addSample') || '新增需求' }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="left"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)" />
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { format, add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    amzPurchaseDetailCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableColumns: tableColumns(this),
      format: (n) => format(n),
      editRules: {
        demandQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        demandDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
          },
        ],
        proofingType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
      },
    }
  },
  computed: {
    height() {
      const h = this.tableHeight - 100
      return h <= 400 ? 400 : h
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzPurchaseDetailCode) return

      this.loading = true
      const res = await this.$api
        .ecomAmzFtyPurchaseSampleListApi({
          amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    async add() {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt({}, -1)
      await $table.setActiveCell(newRow, 'demandDate')
    },
    remove(row) {
      this.$refs.table.remove(row)
      this.$refs.table.updateFooter()
    },
    async validate() {
      return !(await this.$refs.table.validate(true))
    },
    getTableData() {
      const data = this.$refs.table.getTableData()
      return data?.fullData || []
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
